/**
 * @deprecated Use {@link TrailerFuelLevelMerge} instead
 */
export const TrailerFuelLevel = {
  None: 'None',
  Empty: 'Empty',
  Fuel15Percent: '1/8',
  Fuel25Percent: '1/4',
  Fuel35Percent: '3/8',
  Fuel50Percent: '1/2',
  Fuel65Percent: '5/8',
  Fuel75Percent: '3/4',
  Fuel85Percent: '7/8',
  Full: 'Full',
};
/**
 * @deprecated Use {@link TrailerFuelLevelMerge} instead
 */
export type TrailerFuelLevel = (typeof TrailerFuelLevel)[keyof typeof TrailerFuelLevel];

// TODO: firefly-1-9758-ui delete above enum and rename this one to TrailerFuelLevel after merge flag expires
export const TrailerFuelLevelMerge = {
  Fuel_None: 'None',
  Fuel_Empty: 'Empty',
  Fuel_1_8: 'Fuel15Percent',
  Fuel_1_4: 'Fuel25Percent',
  Fuel_3_8: 'Fuel35Percent',
  Fuel_1_2: 'Fuel50Percent',
  Fuel_5_8: 'Fuel65Percent',
  Fuel_3_4: 'Fuel75Percent',
  Fuel_7_8: 'Fuel85Percent',
  Fuel_Full: 'Full',
};

export type TrailerFuelLevelMerge = (typeof TrailerFuelLevelMerge)[keyof typeof TrailerFuelLevelMerge];
